import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AgneseChatPage from "@/pages/AgneseChatPage";
import AdminPage from "@/pages/AdminPage";
import MemberPage from "@/pages/MemberPage";
import PromoPage from "@/pages/PromoPage";
import InfoPage from "@/pages/InfoPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AgneseChatPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/member" element={<MemberPage />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/info" element={<InfoPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
